
export default {
  methods: {
    changePageIndex (index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize (size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    searchFilterData (params) {
      this.pageIndex = 1
      this.getData(params)
    },
    // 自定义列
    selectColumn (params) {
      this.columns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.modalColumn = false
    },
    filterData (params) {
      this.pageIndex = 1
      this.getData(params)
    },
    sortTable (params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getData()
    }
  },
  data () {
    return {
      loading: null,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tableList: [],
      tableCol: []
    }
  }
}
